import React from 'react';

export default function HomeIcon({ className = '', title }) {
  return (

  <svg
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  className={className}
>
  <path
    d="M18 7.69629V18H0V16.5176H16.5V8.42285L9 2.63281L1.5 8.42285V15.0352H0V7.69629L9 0.75L18 7.69629Z"
    fill="currentColor"
  />
  <path
    d="M12 15H6.75V8.25H12V15ZM8.25 13.5H10.5V9.75H8.25V13.5Z"
    fill="currentColor"
  />
</svg>


  );
}

